import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { bootstrapDevEnv } from "@trillion/ui/lib/env";
import { routes } from "./app/routes";
import "./app/globals.css";

// Copy Vite VITE_* env vars into window.__ENV__ so shared packages can read them via getEnv().
bootstrapDevEnv(import.meta.env);

const router = createBrowserRouter(routes);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
